import { createFileRoute, useParams } from '@tanstack/react-router';
import { z } from 'zod';

import { OrganizationDetailScreen } from '@/features/organizations/components/shared/OrganizationDetailScreen';

const searchSchema = z.object({
  tab: z.enum(['locations', 'users']).catch('locations').optional(),
});

export const Route = createFileRoute('/_staff/admin/workspace/organizations/$orgId/')({
  component: WorkspaceOrganizationDetailRoute,
  validateSearch: searchSchema.parse.bind(searchSchema),
});

function WorkspaceOrganizationDetailRoute() {
  const { orgId } = useParams({ from: '/_staff/admin/workspace/organizations/$orgId/' });
  return <OrganizationDetailScreen orgId={orgId} surface="workspace" />;
}
